/**
 * pi-reviews-slider – Swiper init for Review blocks slider.
 * Multi-instance safe: each section uses data-pi-reviews-slider and is initialised once.
 */
(function () {
  function initPIReviewsSlider() {
    if (typeof window.Swiper === 'undefined') return;

    var containers = document.querySelectorAll('[data-pi-reviews-slider]');
    containers.forEach(function (root) {
      var sectionId = root.getAttribute('data-pi-reviews-slider');
      if (!sectionId) return;

      var sliderEl = root.querySelector('.pi-reviews-slider__slider');
      var nextEl = root.querySelector('.pi-reviews-slider__nav--next');
      var prevEl = root.querySelector('.pi-reviews-slider__nav--prev');

      if (!sliderEl || sliderEl.getAttribute('data-pi-reviews-slider-inited') === 'true') return;
      sliderEl.setAttribute('data-pi-reviews-slider-inited', 'true');

      var slidesPerView = 1.2;
      var spaceBetween = 16;
      var breakpoint = 752;
      var slidesPerViewDesk = 3;
      var spaceBetweenDesk = 24;

      try {
        var slidesPerViewAttr = root.getAttribute('data-slides-per-view');
        if (slidesPerViewAttr) slidesPerView = parseFloat(slidesPerViewAttr) || slidesPerView;
        var spaceAttr = root.getAttribute('data-slide-gap');
        if (spaceAttr) spaceBetween = parseInt(spaceAttr, 10) || spaceBetween;
        var breakpointAttr = root.getAttribute('data-breakpoint');
        if (breakpointAttr) breakpoint = parseInt(breakpointAttr, 10) || breakpoint;
        var slidesPerViewDeskAttr = root.getAttribute('data-slides-per-view-desk');
        if (slidesPerViewDeskAttr) slidesPerViewDesk = parseFloat(slidesPerViewDeskAttr) || slidesPerViewDesk;
        var spaceDeskAttr = root.getAttribute('data-slide-gap-desk');
        if (spaceDeskAttr) spaceBetweenDesk = parseInt(spaceDeskAttr, 10) || spaceBetweenDesk;
      } catch (e) {}

      var swiperConfig = {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        loop: true,
        watchOverflow: true,
        breakpoints: {}
      };

      swiperConfig.breakpoints[breakpoint] = {
        slidesPerView: slidesPerViewDesk,
        spaceBetween: spaceBetweenDesk
      };

      if (nextEl && prevEl) {
        swiperConfig.navigation = {
          nextEl: nextEl,
          prevEl: prevEl
        };
      }

      new window.Swiper(sliderEl, swiperConfig);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPIReviewsSlider);
  } else {
    initPIReviewsSlider();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pi-reviews-slider]')) initPIReviewsSlider();
  });
})();
